export default __webpack_public_path__ + "static/media/qorvo.7b925104.png";